import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import QuyetDinhCapVienForm from './QuyetDinhCapVienForm';

const QuyetDinhCapVienModal = ({ dataEdit, setViewMode, isView = false, isUserView = false }) => {
    if (!dataEdit) return null;

    return (
        <Modal show={true} onHide={() => setViewMode('list')} size="lg" backdrop="static">
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title>{isView || isUserView ? 'Kết quả quyết định cấp viện' : 'Quyết định cấp viện'}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0 custom-modal-body" style={{ maxHeight: 'calc(100vh - 150px)', overflowY: 'auto', overflowX: 'hidden' }}>
                <div className="p-3">
                    <QuyetDinhCapVienForm 
                        baoVeCapVienId={dataEdit.id} 
                        readOnly={isView} 
                        isUserView={isUserView} 
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setViewMode('list')}>
                    Đóng
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default QuyetDinhCapVienModal;
